import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export const actionTypes = {
    LOADER: "LOADER",
    BRANCH_LIST : "BRANCH_LIST",
    REFUND_REQUEST_LIST : "REFUND_REQUEST_LIST"
};

export const VfsLoader = () => {
    return {
        type: actionTypes.LOADER,
        vfsloader: true,
    };
};

//  create new branch
export const CreateBranchForVfs = (Data, query, setCorporatemodel) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    return async (dispatch) => {
        await axios
            .post(`${process.env.REACT_APP_API_BASE_URL}/vfs/create-branch`, Data, {
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.LOADER,
                    vfsloader: false,
                });
                setCorporatemodel(false);
                dispatch(VfsBranchlist(query));
                toast.success(response?.data?.message, {
                    theme: "colored",
                    autoClose: 2000,
                });
            })
            .catch((err) => {
                if (err) {
                    dispatch({
                        type: actionTypes.LOADER,
                        vfsloader: false,
                    });
                    toast.error(err?.response?.data?.error, {
                        theme: "colored",
                        autoClose: 2000,
                    });
                }
            });
    };
};

//  get all branch list
export const VfsBranchlist = (query) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
    const master_CorpoId = JSON.parse(authToken)?.data?.corporateID || process.env.REACT_APP_CORPORATE_ID;

    return async (dispatch) => {
        await axios
            .get(`${process.env.REACT_APP_API_BASE_URL}/vfs/get-branch/${master_CorpoId}`, {
                params: { ...query },
                headers: {
                    "x-access-token": token,
                },
            })
            .then((response) => {
                dispatch({
                    type: actionTypes.BRANCH_LIST,
                    BranchList: response.data,
                });
                dispatch({
                    type: actionTypes.LOADER,
                    vfsloader: false,
                });
            })
            .catch((err) => {
                // console.log(err);
                dispatch({
                    type: actionTypes.LOADER,
                    vfsloader: false,
                });
            });
    };
};

//  send vfs mail
export const SendVfsMail = (id) => {
    const authToken = localStorage.getItem("Admin");
    const token = JSON.parse(authToken)?.data?.token;
  
    return async (dispatch) => {
      await axios
        .patch(`${process.env.REACT_APP_API_BASE_URL}/mailstatus/${id}`, null, {
          headers: {
            "x-access-token": token,
          },
        })
        .then((response) => {
            dispatch({
                type: actionTypes.LOADER,
                vfsloader: false,
            });
          toast.success(response?.data?.message, {
            theme: "colored",
            autoClose: 2000,
          });
        })
        .catch((err) => {
          if (err) {
            dispatch({
                type: actionTypes.LOADER,
                vfsloader: false,
            });
          }
          toast.error(err?.response?.data?.error, {
            theme: "colored",
            autoClose: 2000,
          });
        });
    };
  };


//  validate excel file
export const ValidateExcel = (formData, setSelectFile, setShowUploadButton) => async (dispatch) => {
  const authToken = localStorage.getItem("Admin");
  const token = JSON.parse(authToken)?.data?.token;

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/vfs/validate-file`,
      formData,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );

    toast.success(response?.data?.message || "File validated successfully", {
      autoClose: 2000,
      theme: "colored",
    });

    dispatch({
      type: actionTypes.LOADER,
      corporateloader: false,
    });

    setShowUploadButton(true);
    
  } catch (error) {
    setSelectFile(null);
    setShowUploadButton(false);

    const errorMessage = error?.response?.data?.error || "Something went wrong.";

    toast.error(errorMessage, {
      autoClose: 2000,
      theme: "colored",
    });

    dispatch({
      type: actionTypes.LOADER,
      corporateloader: false,
    });
  }
};


//  upload excel file
   export const UploadVfsExcel = (formData , setSelectFile , setShowUploadButton) => async (dispatch) => {
      const authToken = localStorage.getItem("Admin");
      const token = JSON.parse(authToken)?.data?.token;
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/vfs/master-emp-create-file`,
          formData,
          {
            headers: {
              "x-access-token": token,
            },
          }
        );
        toast.success(response.data.message, {
          autoClose: 2000,
          theme: "colored",
        });
        dispatch({
          type: actionTypes.LOADER,
          corporateloader: false,
        });
        setSelectFile(null);
        setShowUploadButton(false);
       
      } catch (error) {
        setShowUploadButton(true);
        const errorMessage = error?.response?.data?.error || "Something went wrong. ";

        toast.error(errorMessage, {
          autoClose: 2000,
          theme: "colored",
        });
        dispatch({
          type: actionTypes.LOADER,
          corporateloader: false,
        });
      } finally{
        dispatch({
          type: actionTypes.LOADER,
          corporateloader: false,
        });
      }
    };

    // payment refund request
export const PaymentRefundRequest = (data,setRefundModal) => async (dispatch) => {
  const authToken = localStorage.getItem("Admin");
  const token = JSON.parse(authToken)?.data?.token;
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}/refund-request`,
        data,
      {
        headers: {
          "x-access-token": token,
        },
      }
    );
    toast.success(response.data.message, {
      autoClose: 2000,
      theme: "colored",
    });
    setRefundModal(false);
    // dispatch({ 
    //   type: actionTypes.LOADER,
    //   loader: false,
    // });
   
  } catch (error) {
    const errorMessage = error?.response?.data?.error || "Something went wrong. Please check your internet connection or try again later.";

    toast.error(errorMessage, {
      autoClose: 2000,
      theme: "colored",
    });
    dispatch({
      type: actionTypes.LOADER,
      corporateloader: false,
    });
  } finally{
    dispatch({
      type: actionTypes.LOADER,
      corporateloader: false,
    });
  }
};

// get refund request list
export const GetRefundRequestList = (id) => {
  const authToken = localStorage.getItem("Admin");
  const token = JSON.parse(authToken)?.data?.token;
  return async (dispatch) => {
    await axios
      .get(`${process.env.REACT_APP_API_BASE_URL}/refund-status/${id}`, {
        headers: {
          "x-access-token": token,
        },
      })
      .then((response) => {
        dispatch({
          type: actionTypes.REFUND_REQUEST_LIST,
          RefundRequestList: response.data,
        });
      })
      .catch((err) => {
        // console.log(err);
      });
  };
};


// vfs website request
export const VfsWebsiteRequest = (data,setRefundModal) => {
  return async (dispatch) => {
    await axios
      .post(`${process.env.REACT_APP_API_BASE_URL}/refund-uk-request`, data)
      .then((response) => {
        toast.success(response?.data?.message, {
          theme: "colored",
          autoClose: 2000,
        });
        setRefundModal(false);
        // dispatch({
        //   type: actionTypes.REFUND_REQUEST_LIST,
        //   RefundRequestList: response.data,
        // });
      })
      .catch((err) => {
        // console.log(err?.response?.data?.error);
        toast.error(err?.response?.data?.error, {
          theme: "colored",
          autoClose: 2000,
        }); 
        // console.log(err);
      });
  };
};